import script from "./FilterModalWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterModalWrapper.vue?vue&type=script&setup=true&lang=js"

import "./FilterModalWrapper.vue?vue&type=style&index=0&id=56263710&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56263710"]])

export default __exports__